// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"app-loading_wrapper__1q4rM","content":"app-loading_content__2tBQG"};